export default __webpack_public_path__ + "static/media/depositoLogo.43c1a4d6.png";